import { useState } from "react"
import styles from "./create-tournament.module.css"
import TournamentForm from "./Create/TournamentForm";
import { api } from "@/utils/apiService";
import { useAuth } from "@/components/context/AuthContext";
import { useTheme } from "@/components/context/ThemeContext";
import { toast } from "react-toastify";

export default function CreateTournamentPage() {
  const {token} = useAuth();
  const { theme } = useTheme();
  const [submittedData, setSubmittedData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")


  const handleSubmit = async (newTournament) => {
    setLoading(true);
    setErrorMessage("");
    try {
      const formData = new FormData();
      formData.append("name", newTournament.name);
      formData.append("description", newTournament.desription);
      formData.append("game", newTournament.game);
      formData.append("registrationPrice", newTournament.registrationPrice);
      formData.append("maxPlayers", newTournament.maxPlayers);
      formData.append("rules", newTournament.rules);
      formData.append("discordLink", newTournament.discordLink);
      formData.append("prizePool", newTournament.prizePool);
      formData.append("tournamentDate", newTournament.tournamentDate);
      formData.append("registrationDeadline", newTournament.registrationDeadline);
      formData.append("bannerImage", newTournament.bannerImage);

      const res = await api.post("/admin/tournaments", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });

      if(res.data.success) {
        const mssg = res.data.message || "Tournament created successfully";
        setSubmittedData(res.data.data)
        toast.success(mssg);
      }
    } catch (error) {
      console.log("Error Creating Tournament ::", error);
      const mssg = error?.response?.data?.message || "Validation Failed";
      toast.error(mssg);
      setErrorMessage(mssg)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={`${styles.container} ${theme === 'dark' ? 'dark' : ''}`}>
      <div className={styles.content}>
        <div className={styles.header}>
          <h1 className={styles.title}>Create Tournament</h1>
          <p className={styles.subtitle}>Launch your esports event and compete for glory and rewards on Pixel Moon</p>
        </div>

        {submittedData ? (
          <div className={styles.successContainer}>
            <div className={styles.successCard}>
              <div className={styles.successIcon}>✓</div>
              <h2 className={styles.successTitle}>Tournament Created Successfully!</h2>
              <p className={styles.successMessage}>
                Your tournament "{submittedData.name}" has been created and is now live.
              </p>
              <div className={styles.successDetails}>
                <div className={styles.detailItem}>
                  <span className={styles.detailLabel}>Tournament:</span>
                  <span className={styles.detailValue}>{submittedData.name}</span>
                </div>
                <div className={styles.detailItem}>
                  <span className={styles.detailLabel}>Game:</span>
                  <span className={styles.detailValue}>{submittedData.game}</span>
                </div>
                <div className={styles.detailItem}>
                  <span className={styles.detailLabel}>Prize Pool:</span>
                  <span className={styles.detailValue}>{submittedData.prizePool || "TBD"}</span>
                </div>
                <div className={styles.detailItem}>
                  <span className={styles.detailLabel}>Max Players:</span>
                  <span className={styles.detailValue}>{submittedData.maxPlayers}</span>
                </div>
              </div>
              <button className={styles.resetButton} onClick={() => setSubmittedData(null)}>
                Create Another Tournament
              </button>
            </div>
          </div>
        ) : (
          <TournamentForm onSubmit={handleSubmit} loading={loading} errorMessage={errorMessage} />
        )}
      </div>
    </div>
  )
}
